function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
export var isLoadedInIFrame = () => {
  return window.self !== window.top;
};
var getWindowObj = () => {
  return isLoadedInIFrame() ? window.parent : window;
};
export var postMessage = (messageChannel, action) => {
  try {
    getWindowObj().postMessage(action, '*', [messageChannel.port2]);
  } catch (ex) {
    console.log('Error in postMessage :', ex);
  }
};
var callbackResponseHandler = payload => {
  var {
    action
  } = payload;
  openUniDirectionalChannel({
    type: "".concat(action.type, "_RESPONSE"),
    payload
  });
};
export var openBiDirectionalChannel = (params, action) => {
  var messageChannel = new MessageChannel();
  postMessage(messageChannel, action);
  var executeCommmand = command => {
    messageChannel.port1.postMessage(command);
  };
  messageChannel.port1.onmessage = event => {
    params.callBackFn(event.data, executeCommmand);
  };
};
export var openBiDirectionalChannelWithResponse = (params, action) => {
  var messageChannel = new MessageChannel();
  postMessage(messageChannel, action);
  messageChannel.port1.onmessage = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (event) {
      var callbackResponse = yield params.callBackFn(event.data, undefined);
      if (callbackResponse) {
        callbackResponseHandler({
          callbackResponse,
          action
        });
      }
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var openUniDirectionalChannel = action => {
  var messageChannel = new MessageChannel();
  postMessage(messageChannel, action);
};